// extracted by mini-css-extract-plugin
export default {"m":"OtherCarts_m__vEmS0","mt":"OtherCarts_mt__Fnloo","tab":"OtherCarts_tab__oEb5F","active":"OtherCarts_active__RAW84"};